var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BFormFile, BButton, BAlert, BOverlay, ModalPlugin } from 'bootstrap-vue';
import VueCropper from 'vue-cropperjs';
import { uploadUserImage } from 'ts/modules/images';
import { ImageStorage } from 'ts/modules/designerStorage';
Vue.use(ModalPlugin);
let ImageUploader = class ImageUploader extends Vue {
    constructor() {
        super(...arguments);
        this.image = null;
        this.croppedImage = null;
        this.src = null;
        this.error = null;
        this.processing = false;
    }
    get aspectRatio() {
        return this.rebateDimensions.width / this.rebateDimensions.length;
    }
    onAspectRationChange() {
        let cropper = this.$refs.cropper;
        if (cropper) {
            cropper.setAspectRatio(this.aspectRatio);
        }
    }
    onImageChange(file) {
        const reader = new FileReader();
        reader.onload = e => {
            var _a, _b;
            if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) {
                this.src = (_b = e.target.result) === null || _b === void 0 ? void 0 : _b.toString();
            }
        };
        reader.readAsDataURL(file);
    }
    cropImage() {
        return __awaiter(this, void 0, void 0, function* () {
            this.processing = true;
            let canvas = this.$refs.cropper
                .getCroppedCanvas();
            this.croppedImage = canvas.toDataURL('image/jpeg');
            if (this.croppedImage) {
                try {
                    // Upload image
                    let fileName = yield uploadUserImage(this.croppedImage);
                    this.error = null;
                    this.$emit('image-uploaded', fileName);
                }
                catch (e) {
                    this.error = "Unable to crop and upload the image you have chosen, please refresh and try again.";
                }
            }
            this.processing = false;
        });
    }
    removeImage() {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.$bvModal.msgBoxConfirm(`Are you sure you want to remove this image?`);
            if (response) {
                this.image = null;
                this.src = null;
                // Delete the image on the folder
                let imageStorage = new ImageStorage();
                imageStorage.delete();
                this.$emit('image-removed');
            }
        });
    }
};
__decorate([
    Prop({ type: Object, required: true })
], ImageUploader.prototype, "rebateDimensions", void 0);
__decorate([
    Watch('aspectRatio')
], ImageUploader.prototype, "onAspectRationChange", null);
ImageUploader = __decorate([
    Component({
        components: {
            BRow, BCol, BFormGroup, BFormFile, BButton, BAlert, BOverlay,
            VueCropper
        }
    })
], ImageUploader);
export default ImageUploader;
